import { lazy } from "react";
import { Navigate } from "react-router-dom";

import Loadable from "../layouts/loader/Loadable";
import ProtectRouteSuperAdmin from "../components/ProtectRouteSuperAdmin";
import ProtectRoute from "../components/ProtectRoute";
import ProtectRouteSuper from "../components/ProtectRouteSuper";
import ProtectRouteDistributor from "../components/ProtectRouteDistributor";
import ProtectRouteAgent from "../components/ProtectRouteAgent";
import ProtectRouteBusiness from "../components/ProtectRouteBusiness";
import ProtectRouteMaster from "../components/ProtectRouteMaster";
import ProtectRouteEmploye from "../components/ProtectRouteEmploye";

/****Layouts*****/
const FullLayout = Loadable(lazy(() => import("../layouts/FullLayout")));
const BlankLayout = Loadable(lazy(() => import("../layouts/BlankLayout")));
const AdminLayout = Loadable(lazy(() => import("../layouts/AdminLayout")));
const SuperLayout = Loadable(lazy(() => import("../layouts/SuperLayout")));
const DistributorLayout = Loadable(
  lazy(() => import("../layouts/DistributorLayout"))
);
const BusinessLayout = Loadable(
  lazy(() => import("../layouts/BusinessLayout"))
);
const MasterLayout = Loadable(lazy(() => import("../layouts/MasterLayout")));
const EmployeLayout = Loadable(lazy(() => import("../layouts/EmployeLayout")));
const SuperAdminLayout = Loadable(
  lazy(() => import("../layouts/SuperAdminLayout"))
);
/***** Pages ****/

/******super admin pages *******/
const SuperAdminDashboard = Loadable(
  lazy(() => import("../views/Dashboards/SuperAdminDashboard"))
);
const AllApi = Loadable(
  lazy(() => import("../views/SuperAdmin/ApiMaster/AllApi"))
);
const AddApi = Loadable(
  lazy(() => import("../views/SuperAdmin/ApiMaster/AddApi"))
);
const UpdateApi = Loadable(
  lazy(() => import("../views/SuperAdmin/ApiMaster/UpdateApi"))
);
const AllServices = Loadable(
  lazy(() => import("../views/SuperAdmin/ServiceMaster/AllServices"))
);
const AddServices = Loadable(
  lazy(() => import("../views/SuperAdmin/ServiceMaster/AddServices"))
);
const CreateCommissionMasterTemplate = Loadable(
  lazy(() =>
    import(
      "../views/SuperAdmin/CommissionMaster/CreateCommissionMasterTemplate"
    )
  )
);
const AdminGetCommissionMasterTemplate = Loadable(
  lazy(() =>
    import("../views/Admin/CommissionModule/GetCommissionMasterTemplate")
  )
);
/******Admin Pages ******/
const AdminDashboard = Loadable(
  lazy(() => import("../views/Dashboards/AdminDashboard"))
);

// profile
const ProfileUpdate = Loadable(
  lazy(() => import("../views/Admin/Profile/ProfileUpdate"))
);
const ChangesPasswordAd = Loadable(
  lazy(() => import("../views/Admin/Profile/ChangesPasswordAd"))
);

/*******UserManagement */
const SuperDistributor = Loadable(
  lazy(() =>
    import("../views/Admin/UserManagement/SuperDistributor/SuperDistributor")
  )
);
const AddSuperDistributor = Loadable(
  lazy(() =>
    import("../views/Admin/UserManagement/SuperDistributor/AddSuperDistributor")
  )
);
const MappingSuperDistributor = Loadable(
  lazy(() =>
    import(
      "../views/Admin/UserManagement/SuperDistributor/MappingSuperDistributor"
    )
  )
);
const Distributor = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Distributor/Distributor"))
);
const AddDistributor = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Distributor/AddDistributor"))
);
const MappingDistributor = Loadable(
  lazy(() =>
    import("../views/Admin/UserManagement/Distributor/MappingDistributor")
  )
);
const Retailer = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Retailer/Retailer"))
);
const AddRetailer = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Retailer/AddRetailer"))
);
const PendingKycVerification = Loadable(
  lazy(() =>
    import("../views/Admin/UserManagement/Retailer/PendingKycVerification")
  )
);
const BlockedIPAddressUsers = Loadable(
  lazy(() =>
    import("../views/Admin/UserManagement/BlockedIPAddressUsers")
  )
);
const UserServiceStatus = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Retailer/UserServiceStatus"))
);
const AdminTopUpReport = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminTopUpReport"))
);
const MappingRetailer = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Retailer/MappingRetailer"))
);
const UpdateProfileMenu = Loadable(
  lazy(() => import("../views/Admin/UserManagement/userProfiles/userProfileMenu"))
);

const AllRole = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Role/AllRole"))
);
const AddNewRole = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Role/AddNewRole"))
);

const BusinessPartner = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Business/BusinessPartner"))
);
const AddBusiness = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Business/AddBusiness"))
);

const MasterDistributor = Loadable(
  lazy(() =>
    import("../views/Admin/UserManagement/MasterDistributor/MasterDistributor")
  )
);
const AddMasterDistributor = Loadable(
  lazy(() =>
    import(
      "../views/Admin/UserManagement/MasterDistributor/AddMasterDistributor"
    )
  )
);

const Employee = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Employee/Employee"))
);
const AddEmployee = Loadable(
  lazy(() => import("../views/Admin/UserManagement/Employee/AddEmployee"))
);
const UserRequest = Loadable(
  lazy(() => import("../views/Admin/UserManagement/UserRequest/UserRequest"))
);
const UserRequestDetails = Loadable(
  lazy(() =>
    import("../views/Admin/UserManagement/UserRequest/UserRequestDetails")
  )
);
const SetUserKycAmount = Loadable(
  lazy(() => import("../views/Admin/UserManagement/KYC/SetUserKycAmount"))
);
const AddDocument = Loadable(
  lazy(() => import("../views/Admin/UserManagement/AddDocument"))
);
const UpdateKYC = Loadable(
  lazy(() => import("../views/Admin/UserManagement/UpdateKYC"))
);
// Balance Request
const ViewBalanceRequestAdmin = Loadable(
  lazy(() => import("../views/Admin/BalanceRequest/ViewBalanceRequestAdmin"))
);
const ViewPendingRequestAdmin = Loadable(
  lazy(() => import("../views/Admin/BalanceRequest/ViewPendingRequestAdmin"))
);

/*********Commission Module **********/
const GetCommissionPlanMaster = Loadable(
  lazy(() =>
    import(
      "../views/Admin/CommissionModule/CommissionPlanMaster/GetCommissionPlanMaster"
    )
  )
);
const CreateCommissionPlanMaster = Loadable(
  lazy(() =>
    import(
      "../views/Admin/CommissionModule/CommissionPlanMaster/CreateCommssionPlanMaster"
    )
  )
);
const CreateCommissionMasterTemplateAdmin = Loadable(
  lazy(() =>
    import(
      "../views/Admin/CommissionModule/CommissionPlanMaster/CreateCommissionMasterTemplateAdmin"
    )
  )
);
const GetCommissionMasterTemplate = Loadable(
  lazy(() =>
    import("../views/Admin/CommissionModule/GetCommissionMasterTemplate")
  )
);
const AllPlans = Loadable(
  lazy(() => import("../views/Admin/CommissionModule/PlanMaster/AllPlans"))
);
const AddPlan = Loadable(
  lazy(() => import("../views/Admin/CommissionModule/PlanMaster/AddPlan"))
);

const AddServiceCategory = Loadable(
  lazy(() =>
    import(
      "../views/Admin/CommissionModule/ServiceCategoryMaster/AddServiceCategory"
    )
  )
);
const AllServiceCategory = Loadable(
  lazy(() =>
    import(
      "../views/Admin/CommissionModule/ServiceCategoryMaster/AllServiceCategory"
    )
  )
);

/*** Manage credit Detaials */
const CreditDebitUsers = Loadable(
  lazy(() => import("../views/Admin/ManageCreditDetails/CreditDebitUsers"))
);
const CreditDebitDetails = Loadable(
  lazy(() => import("../views/Admin/ManageCreditDetails/CreditDebitDetails"))
);

/*** Manage Bank */

const AdminSelfBank = Loadable(
  lazy(() => import("../views/Admin/ManageBank/SelfBank/AdminSelfBank"))
);
const AdminSelfBankAdd = Loadable(
  lazy(() => import("../views/Admin/ManageBank/SelfBank/AdminSelfBankAdd"))
);
const AdminSelfbankUpdate = Loadable(
  lazy(() => import("../views/Admin/ManageBank/SelfBank/AdminSelfbankUpdate"))
);
const MainBankList = Loadable(
  lazy(() => import("../views/Admin/ManageBank/ManageMainBank/MainBankList"))
);
const BankDataManager = Loadable(
  lazy(() => import("../views/Admin/ManageBank/BankDataManager"))
);
const AddMainBank = Loadable(
  lazy(() => import("../views/Admin/ManageBank/ManageMainBank/AddMainBank"))
);
const PaymentOperatorList = Loadable(
  lazy(() =>
    import("../views/Admin/ManageBank/PaymentOperator/PaymentOperatorList")
  )
);

// HelpDesk
const ComplaintList = Loadable(
  lazy(() => import("../views/HelpDesk/ComplaintList"))
);
const NewComplaint = Loadable(
  lazy(() => import("../views/HelpDesk/NewComplaint"))
);
const ComplaintDetails = Loadable(
  lazy(() => import("../views/HelpDesk/ComplaintDetails"))
);

// Management
const AppLoginPin = Loadable(
  lazy(() => import("../views/Admin/Management/AppLoginPin"))
);
const ChangeMobileNo = Loadable(
  lazy(() => import("../views/Admin/Management/AppLoginPin"))
);
const ComplaintManager = Loadable(
  lazy(() => import("../views/Admin/Management/ComplaintManager"))
);
const CustomerLimitInc = Loadable(
  lazy(() => import("../views/Admin/Management/CustomerLimitInc"))
);
const CustomerNameUpdate = Loadable(
  lazy(() => import("../views/Admin/Management/CustomerNameUpdate"))
);
const EnrollmentList = Loadable(
  lazy(() => import("../views/Admin/Management/EnrollmentList"))
);
const LoginHistory = Loadable(
  lazy(() => import("../views/Admin/Management/LoginHistory"))
);
const Notification = Loadable(
  lazy(() => import("../views/Admin/Management/Notification"))
);
const NotificationAdd = Loadable(
  lazy(() => import("../views/Admin/Management/NotificationAdd"))
);
const ServicesControl = Loadable(
  lazy(() => import("../views/Admin/Management/ServicesControl"))
);
const UserManagement = Loadable(
  lazy(() => import("../views/Admin/Management/UserManagement"))
);
const SystemSetting = Loadable(
  lazy(() => import("../views/Admin/Management/SystemSetting"))
);
// APP Config
const AppConfig = Loadable(
  lazy(() => import("../views/Admin/ApiConfig/AppConfig"))
);
const APILogs = Loadable(lazy(() => import("../views/Admin/ApiConfig/APILogs")));
const WebHook = Loadable(
  lazy(() =>
    import("../views/Admin/ApiConfig/WebHook")
  )
);
const SMSLogs = Loadable(lazy(() => import("../views/Admin/ApiConfig/SMSLogs")));
const SetCharges = Loadable(
  lazy(() =>
    import("../views/Admin/ApiConfig/SetCharges")
  )
);

const BusinessRights = Loadable(
  lazy(() => import("../views/Admin/Management/BusinessRights"))
);
// Admin Rports
const AdminLedgeReports = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminLedgerReports"))
);
const AdminTransactionReport = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminTransactionReport"))
);
const AdminBeneficiaryVerifyTransactionReport = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminBeneficiaryVerifyTransactionReport"))
);
const AdminPendingTransectionReport = Loadable(
  lazy(() => import('../views/Admin/Reports/AdminPendingTransectionReport')),
);
const AdminFailedTransectionReport = Loadable(
  lazy(() => import('../views/Admin/Reports/AdminFailedTransectionReport')),
);
const AdminWalletToWalletTransactionReport = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminWalletToWallet"))
);
const AdminTransactionByIPAddressReport = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminTransactionByIPAddressReport"))
);
const AdminChangeStatus = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminChangeStatus"))
);
const AdminBillPaymentReports = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminBillPaymentReports"))
);
const KycPaymentsStatus = Loadable(
  lazy(() => import("../views/Admin/Reports/KycPaymentsStatus"))
);
const AEPSTransactionReportsAdmin = Loadable(
  lazy(() => import("../views/Admin/Reports/AEPSTransactionReportsAdmin"))
);
const AdminPGReports = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminPGReports"))
);
const AdminSelfLedger = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminSelfLedger"))
);
const CommissionReports = Loadable(
  lazy(() => import("../views/Admin/Reports/CommissionReports"))
);
const AdminCommissionTransectionReports = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminCommissionTransectionReports"))
);
const PayOutTransactionReports = Loadable(
  lazy(() => import("../views/Admin/Reports/PayOutTransactionReports"))
);
const MoneyTransferHoldCasesAdmin = Loadable(
  lazy(() => import("../views/Admin/Reports/MoneyTransferHoldCasesAdmin"))
);
const AdminLedgeReconsileReports = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminLedgeReconsileReports"))
);
const DaileyTrasactionReports = Loadable(
  lazy(() => import("../views/Admin/Reports/DaileyTrasactionReports"))
);
const AdminBusinessReport = Loadable(lazy(()=> import('../views/Admin/Reports/AdminBusinessReport')))
const AdminBusinessReports = Loadable(lazy(()=> import('../views/Admin/Reports/AdminBusinessReports')))
const AdminDailyBusinessReports = Loadable(lazy(()=> import('../views/Admin/Reports/AdminDailyBusinessReports')))
const AgentAccountStatusReports = Loadable(
  lazy(() => import("../views/Admin/Reports/AccountReport/AccountStatusReports"))
);
const AdminAPIRequestReponseStatus = Loadable(
  lazy(() => import("../views/Admin/Reports/AdminAPIRequestReponseStatus"))
);
const CashoutTransactionReportsAdmin = Loadable(
  lazy(() => import("../views/Admin/Reports/CashoutTransactionAdmin"))
);
const RefundReportAdmin = Loadable(
  lazy(() => import("../views/Admin/Reports/RefundReportAdmin"))
);
const ChangeTpinAdmin = Loadable(
  lazy(() => import("../views/Admin/Management/ChangeTpin"))
); // Admin Rports
const PgTransactionReportsAdmin = Loadable(
  lazy(() => import("../views/Admin/Reports/PgTransactionReportsAdmin"))
);
/***** Super Distributor****/
const SuperDistributorDashboard = Loadable(
  lazy(() => import("../views/Dashboards/SuperDistributorDashboard"))
);
const SuperDocumentKyc = Loadable(
  lazy(() => import("../views/SuperDistributor/AddDocumentKyc"))
);

/***** DistributorPages ****/

const AllPlansSD = Loadable(
  lazy(() =>
    import("../views/SuperDistributor/CommissionModule/PlanMaster/AllPlans")
  )
);
const AddPlanSD = Loadable(
  lazy(() =>
    import("../views/SuperDistributor/CommissionModule/PlanMaster/AddPlan")
  )
);

const AllPlansD = Loadable(
  lazy(() =>
    import("../views/Distributor/CommissionModule/PlanMaster/AllPlans")
  )
);
const AddPlanD = Loadable(
  lazy(() => import("../views/Distributor/CommissionModule/PlanMaster/AddPlan"))
);

const DistributorDashboard = Loadable(
  lazy(() => import("../views/Dashboards/DistributorDashboard"))
);

const TransactionRecieptDistributor = Loadable(
  lazy(() => import("../views/Distributor/Profile/TransactionReciept"))
);

const DistributorDocsKyc = Loadable(
  lazy(() => import("../views/Distributor/AddDocumentKyc"))
);

const CreateRetailerDistributor = Loadable(
  lazy(() =>
    import("../views/Distributor/ManageRetailer/CreateRetailerDistributor")
  )
);

const ViewRetailerDistributor = Loadable(
  lazy(() =>
    import("../views/Distributor/ManageRetailer/ViewRetailerDistributor")
  )
);

const RetailerDocs = Loadable(
  lazy(() => import("../views/Distributor/ManageRetailer/RetailerDocs"))
);

const ManageCreditDebitDistributor = Loadable(
  lazy(() =>
    import(
      "../views/Distributor/ManageCreditDebit/ManageCreditDebitDistributor"
    )
  )
);

const CreditAmountToRetailer = Loadable(
  lazy(() =>
    import("../views/Distributor/ManageCreditDebit/CreditAmountToRetailer")
  )
);

const CreditDetailsDistributor = Loadable(
  lazy(() =>
    import("../views/Distributor/CreditDetail/CreditDetailsDistributor")
  )
);

const LedgerReportDistributor = Loadable(
  lazy(() => import("../views/Distributor/Reports/LedgerReportDistributor"))
);
const AllRetailorReportsDistributor = Loadable(
  lazy(() => import("../views/Distributor/Reports/AllReports"))
);
const CommisionReportDistributor = Loadable(
  lazy(() => import('../views/Distributor/Reports/CommissionReports')),
);
const BillPaymentReciept = Loadable(
  lazy(() => import('../views/Distributor/Reports/BillPaymentReciept')),
);
// Balance Request
const BalanceRequestHistoryDistributor = Loadable(
  lazy(() =>
    import("../views/Distributor/BalanceRequest/BalanceRequestHistory")
  )
);
const PendingBalanceRequestDistributor = Loadable(
  lazy(() =>
    import("../views/Distributor/BalanceRequest/PendingBalanceRequestDistributor")
  )
);
const NewBalanceRequestDistributor = Loadable(
  lazy(() => import("../views/Distributor/BalanceRequest/NewBalanceRequest"))
);
const AddNewBankDistributor = Loadable(
  lazy(() => import("../views/Distributor/SelfBank/AddNewBank"))
);
const DistributorBankList = Loadable(
  lazy(() => import("../views/Distributor/SelfBank/DistributorBankList"))
);
const UpdateDistributorBank = Loadable(
  lazy(() => import("../views/Distributor/SelfBank/UpdateDistributorBank"))
);
const ChangePasswordDistributer = Loadable(
  lazy(() => import("../views/Distributor/Profile/ChangePassword"))
);
// profile
const UpdateProfileDistributor = Loadable(
  lazy(() => import("../views/Distributor/Profile/UpdateProfileDistributor"))
);
/***** Super Distributor****/
// const SuperDistributorDashboard = Loadable(
//   lazy(() => import('../views/Dashboards/SuperDistributorDashboard')),
// );

const SuperViewRetailerDistributor = Loadable(
  lazy(() =>
    import(
      "../views/SuperDistributor/ManageDistributor/SuperViewRetailerDistributor"
    )
  )
);

const SuperCreateRetailerDistributor = Loadable(
  lazy(() =>
    import(
      "../views/SuperDistributor/ManageDistributor/SuperCreateRetailerDistributor"
    )
  )
);

const DistributorDocs = Loadable(
  lazy(() =>
    import("../views/SuperDistributor/ManageDistributor/DistributorDocs")
  )
);

const SuperManageCreditDebitDistributor = Loadable(
  lazy(() =>
    import(
      "../views/SuperDistributor/ManageCreditDebit/SuperManageCreditDebitDistributor"
    )
  )
);

const SuperCreditAmountToRetailer = Loadable(
  lazy(() =>
    import(
      "../views/SuperDistributor/ManageCreditDebit/SuperCreditAmountToRetailer"
    )
  )
);

const MasterManageCreditDebitDistributor = Loadable(
  lazy(() =>
    import(
      "../views/MasterDistributor/ManageCreditDebit/MasterManageCreditDebitDistributor"
    )
  )
);

const MasterCreditAmountToRetailer = Loadable(
  lazy(() =>
    import(
      "../views/MasterDistributor/ManageCreditDebit/MasterCreditAmountToRetailer"
    )
  )
);

const SuperCreditDetailsDistributor = Loadable(
  lazy(() =>
    import(
      "../views/SuperDistributor/CreditDetail/SuperCreditDetailsDistributor"
    )
  )
);

const CommisionSuperReportDistributor = Loadable(
  lazy(() =>
    import("../views/SuperDistributor/Reports/CommisionSuperReportDistributor")
  )
);

const LedgerMasterReportDistributor = Loadable(
  lazy(() =>
    import("../views/MasterDistributor/Reports/LedgerMasterReportDistributor")
  )
);

const LedgerSuperReportDistributor = Loadable(
  lazy(() =>
    import("../views/SuperDistributor/Reports/LedgerSuperReportDistributor")
  )
);

const AllSuperDistributorReports = Loadable(
  lazy(() =>
    import("../views/SuperDistributor/Reports/AllSuperDistributorReports")
  )
);

// Profile

const UpdateProfileMenuSD = Loadable(
  lazy(() => import("../views/SuperDistributor/UpdateProfileMenu"))
);

const UpdateProfileMenuD = Loadable(
  lazy(() => import("../views/Distributor/UpdateProfileMenu"))
);

const UpdateProfileSD = Loadable(
  lazy(() => import("../views/SuperDistributor/Profile/ProfileUpdateSD"))
);
const ChangePasswordSP = Loadable(
  lazy(() => import("../views/SuperDistributor/Profile/ChangePasswordSP"))
);

// SELF BANK
const AddNewBankSuperDistributor = Loadable(
  lazy(() => import("../views/SuperDistributor/SelfBank/AddNewBank"))
);
const SPDistributorBankList = Loadable(
  lazy(() => import("../views/SuperDistributor/SelfBank/SPDistributorBankList"))
);
const UpdateSPDistributorBank = Loadable(
  lazy(() => import("../views/SuperDistributor/SelfBank/UpdateDistributorBank"))
);

// BALANCE REQUEST
const BalanceRequestHistorySuper = Loadable(
  lazy(() =>
    import("../views/SuperDistributor/BalanceRequest/BalanceRequestHistory")
  )
);
const NewBalanceRequestSuper = Loadable(
  lazy(() =>
    import("../views/SuperDistributor/BalanceRequest/NewBalanceRequest")
  )
);
const PendingBalanceRequestSuperDistributor = Loadable(
  lazy(() =>
    import("../views/SuperDistributor/BalanceRequest/PendingBalanceRequestSuperDistributor")
  )
);

// const ChangePasswordDistributor = Loadable(lazy(() => import('../views/Retailer/User/ChangePassword')));
/***** RetailerPages ****/
const RetailerDashboard = Loadable(
  lazy(() => import("../views/Dashboards/RetailerDashboard"))
);

const RetailerTermsAndCondition = Loadable(
  lazy(() => import("../views/Retailer/TermsAndCondition"))
);

const RetailerPrivacyPolicy = Loadable(
  lazy(() => import("../views/Retailer/PrivacyPolicy"))
);

/****Banking Services */
const DMTDashboard = Loadable(
  lazy(() => import("../views/Retailer/BankingServices/DMT/DMTDashboard"))
);
const SearchCustomer = Loadable(
  lazy(() => import("../views/Retailer/BankingServices/DMT/SearchCustomer"))
);
const AddCustomer = Loadable(
  lazy(() => import("../views/Retailer/BankingServices/DMT/CustomerAdd"))
);
const BenificiaryList = Loadable(
  lazy(() => import("../views/Retailer/BankingServices/DMT/BenificiaryList"))
);
const AddBenificiary = Loadable(
  lazy(() => import("../views/Retailer/BankingServices/DMT/BenificiaryAdd"))
);
const BenificiaryDetails = Loadable(
  lazy(() => import("../views/Retailer/BankingServices/DMT/BenificiaryDetails"))
);
const TransactionReciept = Loadable(
  lazy(() => import("../views/Retailer/BankingServices/DMT/TransactionReciept"))
);

// Payout-4 (DIGIKHATA)
const SearchDIGICustomer = Loadable(
  lazy(() => import("../views/Retailer/BankingServices/DIGIKHATA/SearchCustomer"))
);
const DGKBenificiaryDetails = Loadable(
  lazy(() =>
    import("../views/Retailer/BankingServices/DIGIKHATA/DGKBenificiaryDetails")
  )
);

// Payment Collection
const PCSearchCustomer = Loadable(
  lazy(() => import("../views/Retailer/PaymentCollection/PCSearchCustomer"))
);

// PAYOUT-1
const SearchPayoutCustomer = Loadable(
  lazy(() =>
    import("../views/Retailer/BankingServices/Payout/SearchPayoutCustomer")
  )
);
const SearchCustomerList = Loadable(
  lazy(() =>
    import("../views/Retailer/BankingServices/Payout/SearchCustomerList")
  )
);
const SearchCustomerListSOLICITEK = Loadable(
  lazy(() =>
    import("../views/Retailer/BankingServices/Payout/SOLICITEK/SearchCustomerList")
  )
);
const RentPayoutDashboard = Loadable(
  lazy(() => import("../views/Retailer/RentPayout/RentpayoutDashboard"))
);
const AddCustomerPayout = Loadable(
  lazy(() =>
    import("../views/Retailer/BankingServices/Payout/AddCustomerPayout")
  )
);
const PayAddBeneficiary = Loadable(
  lazy(() =>
    import("../views/Retailer/BankingServices/Payout/PayAddBeneficiary")
  )
);
const PayoutBeneficiaryList = Loadable(
  lazy(() =>
    import("../views/Retailer/BankingServices/Payout/PayoutBeneficiaryList")
  )
);
const PayOutBeniDetails = Loadable(
  lazy(() =>
    import("../views/Retailer/BankingServices/Payout/PayOutBeniDetails")
  )
);

/****Self Bank ****/
const RetailorBankList = Loadable(
  lazy(() => import("../views/Retailer/SelfBank/RetailorBankList"))
);

const AddNewBank = Loadable(
  lazy(() => import("../views/Retailer/SelfBank/AddNewBank"))
);
const UpdateRetailorBank = Loadable(
  lazy(() => import("../views/Retailer/SelfBank/UpdateRetailorBank"))
);

// Balance Request
const BalanceRequestHistory = Loadable(
  lazy(() => import("../views/Retailer/BalanceRequest/BalanceRequestHistory"))
);
const NewBalanceRequest = Loadable(
  lazy(() => import("../views/Retailer/BalanceRequest/NewBalanceRequest"))
);
const ComplaintAddAgent = Loadable(
  lazy(() => import("../views/Retailer/Profile/ComplaintAddAgent"))
);
const ComplaintListAgent = Loadable(
  lazy(() => import("../views/Retailer/Profile/ComplaintListAgent"))
);

/****Retailor Reports */
const AllRetailorReports = Loadable(
  lazy(() => import("../views/Retailer/Reports/AllRetailorReports"))
);

const CashoutReport = Loadable(
  lazy(() => import("../views/Retailer/Reports/CashoutTransaction"))
)
// Profile
const UpdateProfileAgent = Loadable(
  lazy(() => import("../views/Retailer/Profile/UpdateProfileAgent"))
);
const Certificate = Loadable(
  lazy(() => import("../views/Retailer/Profile/Certificate"))
);
const SetTPIN = Loadable(
  lazy(() => import("../views/Retailer/Profile/SetTPIN"))
);
const ResetTPIN = Loadable(
  lazy(() => import("../views/Retailer/Profile/ResetTPIN"))
);
const ChangePassword = Loadable(
  lazy(() => import("../views/Retailer/Profile/ChangePassword"))
);
/***** BusinessPages ****/
const BusinessPartnerDashboard = Loadable(
  lazy(() => import("../views/Dashboards/BusinessPartnerDashboard"))
);
//Balance Request
const BalanceRequestHistoryBusiness = Loadable(
  lazy(() => import("../views/Business/BalanceRequest/BalanceRequestHistory"))
);
const CreateBalanceRequest = Loadable(
  lazy(() => import("../views/Business/BalanceRequest/CreateBalanceRequest"))
);
// self bank
const BusinessBankList = Loadable(
  lazy(() => import("../views/Business/SelfBank/BusinessBankList"))
);
const AddBusinessBank = Loadable(
  lazy(() => import("../views/Business/SelfBank/AddBusinessBank"))
);
const UpdateBusinessBank = Loadable(
  lazy(() => import("../views/Business/SelfBank/UpdateBusinessBank"))
);
const UpdateProfileBusiness = Loadable(
  lazy(() => import("../views/Business/Profile/UpdateProfileBusiness"))
);
const ChangePasswordBD = Loadable(
  lazy(() => import("../views/Business/Profile/ChangePasswordBD"))
);
/***** MasterPages ****/
const MasterDistributorDashboard = Loadable(
  lazy(() => import("../views/Dashboards/MasterDistributorDashboard"))
);
const MasterDocumentKyc = Loadable(
  lazy(() => import("../views/MasterDistributor/AddDocumentKyc"))
);
// Balance Request
const BalanceRequestHistoryMaster = Loadable(
  lazy(() =>
    import(
      "../views/MasterDistributor/BalanceRequest/BalanceRequestHistoryMaster"
    )
  )
);
const NewBalanceRequestMaster = Loadable(
  lazy(() =>
    import("../views/MasterDistributor/BalanceRequest/NewBalanceRequestMaster")
  )
);
// credit Details
const MasterCreditDetails = Loadable(
  lazy(() =>
    import("../views/MasterDistributor/CreditDetail/MasterCreditDetails")
  )
);
// self Bank
const MasterBankList = Loadable(
  lazy(() => import("../views/MasterDistributor/SelfBank/MasterBankList"))
);
const AddMasterBank = Loadable(
  lazy(() => import("../views/MasterDistributor/SelfBank/AddMasterBank"))
);
const UpdateMasterBank = Loadable(
  lazy(() => import("../views/MasterDistributor/SelfBank/UpdateMasterBank"))
);

// manage SuperDistributor

const MasterCreateSuperDistributor = Loadable(
  lazy(() =>
    import(
      "../views/MasterDistributor/ManageDistributor/MasterCreateSuperDistributor"
    )
  )
);
const MasterViewSuperDistributor = Loadable(
  lazy(() =>
    import(
      "../views/MasterDistributor/ManageDistributor/MasterViewSuperDistributor"
    )
  )
);
const SuperDistributorDocs = Loadable(
  lazy(() =>
    import("../views/MasterDistributor/ManageDistributor/SuperDistributorDocs")
  )
);

/***** EmployePages ****/
const EmployeeDashboard = Loadable(
  lazy(() => import("../views/Dashboards/EmployeeDashboard"))
);

// Balance Request
const NewBalanceRequestEmployee = Loadable(
  lazy(() =>
    import("../views/Employe/BalanceRequest/NewBalanceRequestEmployee")
  )
);
const BalanceRequestHistoryEmployee = Loadable(
  lazy(() =>
    import("../views/Employe/BalanceRequest/BalanceRequestHistoryEmployee")
  )
);

// Self Bank
const EmployeeBankList = Loadable(
  lazy(() => import("../views/Employe/SelfBank/EmployeeBankList"))
);
const AddEmployeeBank = Loadable(
  lazy(() => import("../views/Employe/SelfBank/AddEmployeeBank"))
);
const UpdateEmployeeBank = Loadable(
  lazy(() => import("../views/Employe/SelfBank/UpdateEmployeeBank"))
);
const ChangePasswordEMP = Loadable(
  lazy(() => import("../views/Employe/Profile/ChangePasswordEMP"))
);
const ChangePasswordMd = Loadable(
  lazy(() => import("../views/MasterDistributor/Profile/ChangePasswordMD"))
);
const UpdateProfileMD = Loadable(
  lazy(() => import("../views/MasterDistributor/Profile/ProfileUpdateMD"))
);
/***** Pages ****/

/*** Recharge ****/
const DTHRecharge = Loadable(
  lazy(() => import("../views/Retailer/Recharge/DthRecharge"))
);
const MobileRecharge = Loadable(
  lazy(() => import("../views/Retailer/Recharge/MobileRecharge"))
);
const LICPayments = Loadable(
  lazy(() => import("../views/Retailer/Recharge/LICPayments"))
);
const LPGGasPayment = Loadable(
  lazy(() => import("../views/Retailer/Recharge/LPGGasPayment"))
);
const ElectricityBill = Loadable(
  lazy(() => import("../views/Retailer/Recharge/ElectricityBill"))
);
const FastTagPayment = Loadable(
  lazy(() => import("../views/Retailer/Recharge/FastTagPayment"))
);
const AddDocumentKyc = Loadable(
  lazy(() => import("../views/Retailer/AddDocumentKyc"))
);
const PayementReciept = Loadable(
  lazy(() => import("../views/Retailer/Recharge/PayementReciept"))
);
// BILL PAYMENTS
const BillPaymentsBa = Loadable(
  lazy(() => import("../views/Retailer/BillPayments/BillAvenue/BillPayments"))
);
const BillPaymentsDash = Loadable(
  lazy(() => import("../views/Retailer/BillPayments/Indicore/BillPaymentsDash"))
);

const BillPaymentsInd = Loadable(
  lazy(() => import("../views/Retailer/BillPayments/Indicore/BillPaymentsInd"))
);

// WALLET PAY
const WalletPay = Loadable(
  lazy(() => import("../views/Retailer/WalletPay/WalletPay"))
);

// WALLET PAY
const WalletToWallet = Loadable(
  lazy(() => import("../views/Retailer/WalletPay/WalletToWallet"))
);
// REMITTER
const REMITTER = Loadable(
  lazy(() => import("../views/Retailer/BankingServices/DMT/REMITTER"))
);

const PipDMTSearchCustomer = Loadable(
  lazy(() => import("../views/Retailer/BankingServices/PIPDMT/SearchCustomer"))
);
/****AEPS *****/
const AepsSearch = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSIservue/AepsSearch"))
);
const AEPSOnboarding = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSIservue/AEPSOnboarding"))
);
const AEPSCaptureIs = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSIservue/AEPSCaptureIs"))
);
const OnboardingUser = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSPs/OnboardingUser"))
);
const AEPSSearchPs = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSPs/AEPSSearchPs"))
);
const AEPSDailyAuthantication = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSPs/AEPSDailyAuthantication"))
);
const AEPSRegistrationUser = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSPs/AEPSRegistrationUser"))
);
const AEPSWithdralCapture = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSPs/AEPSWithdralCapture"))
);
const AEPSBalAndMinistatment = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSPs/AEPSBalAndMinistatment"))
);
const AEPSTransactionSelect = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSPs/AEPSTransactionSelect"))
);
const AEPSTransactionReciept = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSTransactionReciept"))
);
const AEPSToDMTTransfer = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSToDMTTransfer"))
);
const AEPSPayout = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSPayout"))
);
const AEPSPayoutBeneficiaryDetails = Loadable(
  lazy(() => import("../views/Retailer/AEPS/AEPSPayoutBeneficiaryDetails"))
);
// const AEPSTransactionReports = Loadable(lazy(() => import('../views/Retailer/')));
// QR SERVICES
const QRServices = Loadable(
  lazy(() => import("../views/Retailer/QRServices/QRServices"))
);
// PG
const PaymentGetway = Loadable(
  lazy(() => import("../views/Retailer/PG/PaymentGetway"))
);
const PaymentGetway1 = Loadable(
  lazy(() => import("../views/Retailer/PG/PaymentGetway1"))
);
const PaymentGetway2 = Loadable(
  lazy(() => import("../views/Retailer/PG/PaymentGetway2"))
);
const PaymentGetwayVegaah = Loadable(
  lazy(() => import("../views/Retailer/PG/PaymentGetwayVegaah"))
);
const UpiEcollection = Loadable(
  lazy(() => import("../views/Retailer/PG/UpiEcollection"))
);
const PGToMainWalletTransfer = Loadable(
  lazy(() => import("../views/Retailer/PG/PGToMainWalletTransfer"))
);
// PG Dashboard
const PaymentGetwayDashboard = Loadable(
  lazy(() => import("../views/Retailer/PG/PaymentGetwayDashboard"))
);
// CMS
const GetCMSLink = Loadable(
  lazy(() => import("../views/Retailer/CMS/GetCMSLink"))
);
// BUS BOOKING
const BusBooking = Loadable(
  lazy(() => import("../views/Retailer/BusBooking/BusBooking"))
);

// DHANPAY
const QuickDhanPay = Loadable(
  lazy(() => import("../views/Retailer/QuickDhan/QuickDhanPay"))
);

// Agent Reports
const AgentLedgerReport = Loadable(
  lazy(() => import("../views/Retailer/Reports/LedgerReport"))
);
const AgentTransactionReport = Loadable(
  lazy(() => import("../views/Retailer/Reports/DMTTransactionReports"))
);
const AgentBeneVerifyReport = Loadable(
  lazy(() => import("../views/Retailer/Reports/BeneVerifyReports"))
);
const AgentAEPSTransactionReport = Loadable(
  lazy(() => import("../views/Retailer/Reports/AEPSTransactionReports"))
);
const AgentPGTransactionReport = Loadable(
  lazy(() => import("../views/Retailer/Reports/PaymentGetwayReports"))
);
const AgentTDSTransactionReport = Loadable(
  lazy(() => import("../views/Retailer/Reports/GetTDSTransactionReports"))
);
const AgentGSTTransactionReport = Loadable(
  lazy(() => import("../views/Retailer/Reports/GetGSTTransactionReports"))
);
const AgentBillPayementReport = Loadable(
  lazy(() => import("../views/Retailer/Reports/RechargeReport"))
);
const DevelopersDocument = Loadable(lazy(() => import("../views/Retailer/DeveloperDocuments/DevelopersDocument")));

/***** Auth Pages ****/
const Home = Loadable(lazy(() => import("../views/Web/Home")));
const About = Loadable(lazy(() => import("../views/Web/AboutUs")));
const SMSMSMESolutions = Loadable(
  lazy(() => import("../views/Web/Sme_msme_solutions"))
);
const CorporateSolution = Loadable(
  lazy(() => import("../views/Web/Corporate_solution"))
);
const InstitutionalSolution = Loadable(
  lazy(() => import("../views/Web/institutional_solution"))
);
const Services = Loadable(lazy(() => import("../views/Web/Services")));
const Contact = Loadable(lazy(() => import("../views/Web/Contact")));
const OurPartner = Loadable(lazy(() => import("../views/Web/OurPartner")));
// const BusinessWithUs = Loadable(lazy(() => import('../views/Web/BusinessWithUs')));
const PrivacyPolicy = Loadable(
  lazy(() => import("../views/Web/PrivacyPolicy"))
);
const RefundPolicy = Loadable(lazy(() => import("../views/Web/RefundPolicy")));
// const Career = Loadable(lazy(() => import('../views/Web/Career')));
const TermsAndCondition = Loadable(
  lazy(() => import("../views/Web/TermsAndCondition"))
);
const Error = Loadable(lazy(() => import("../views/Web/Error")));
const Login = Loadable(lazy(() => import("../views/Web/Login")));
const OTPVerification = Loadable(
  lazy(() => import("../views/Web/OTPVerification"))
);
const ForgotPassword = Loadable(
  lazy(() => import("../views/Web/ForgotPassword"))
);
const Maintanance = Loadable(lazy(() => import("../views/Web/Maintanance")));
const LockScreen = Loadable(lazy(() => import("../views/Web/LockScreen")));
const Signup = Loadable(lazy(() => import("../views/Web/Signup")));
/*****Routes******/

const ThemeRoutes = [
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "404", element: <Error /> },
      { path: "*", element: <Navigate to="/404" /> },
      { path: "/", name: "home", element: <Login /> },
      { path: "/home", name: "home", element: <Home /> },
      { path: "about", element: <About /> },
      { path: "sme-msme-solutions", element: <SMSMSMESolutions /> },
      { path: "corporate-solution", element: <CorporateSolution /> },
      { path: "institutional-solution", element: <InstitutionalSolution /> },
      { path: "services", element: <Services /> },
      { path: "contact", element: <Contact /> },
      { path: "OurPartner", element: <OurPartner /> },
      // { path: 'PartnerWithUs', element: <BusinessWithUs /> },
      { path: "privacypolicy", element: <PrivacyPolicy /> },
      { path: "refundpolicy", element: <RefundPolicy /> },
      { path: "termsandcondition", element: <TermsAndCondition /> },
      { path: "Login", element: <Login /> },
      { path: "ForgotPassword", element: <ForgotPassword /> },
      { path: "OTPVerification", element: <OTPVerification /> },
      { path: "maintanance", element: <Maintanance /> },
      { path: "lockscreen", element: <LockScreen /> },
      // { path: 'Career', element: <Career /> },
      { path: "signup", element: <Signup /> },
    ],
  },
  // AADMIN SCREEN
  {
    path: "/",
    element: <ProtectRoute Component={AdminLayout} />,
    children: [
      // Help Desk---start
      {
        path: "/helpDesk/complaintList",
        name: "HelpDeck",
        exact: true,
        element: <ComplaintList />,
      },
      {
        path: "/helpDesk/newComplaint",
        name: "HelpDeck",
        exact: true,
        element: <NewComplaint />,
      },
      {
        path: "/helpDesk/complaintDetails",
        name: "HelpDeck",
        exact: true,
        element: <ComplaintDetails />,
      },
      // Help Desk---End

      {
        path: "/Profile/ProfileUpdate",
        name: "ProfileUpdate",
        exact: true,
        element: <ProfileUpdate />,
      },
      {
        path: "/Admin/ChangesPasswordAd",
        name: "ProfileUpdate",
        exact: true,
        element: <ChangesPasswordAd />,
      },
      {
        path: "/dashboards/admindashboard",
        name: "admin",
        exact: true,
        element: <AdminDashboard />,
      },
      {
        path: "/UserManagement/SuperDistributor",
        name: "SuperDistributor",
        exact: true,
        element: <SuperDistributor />,
      },
      {
        path: "/UserManagement/AddSuperDistributor",
        name: "AddSuperDistributor",
        exact: true,
        element: <AddSuperDistributor />,
      },
      {
        path: "/Admin/MappingSuperDistributor",
        name: "MappingSuperDistributor",
        exact: true,
        element: <MappingSuperDistributor />,
      },
      {
        path: "/Distributor/Distributor",
        name: "Distributor",
        exact: true,
        element: <Distributor />,
      },
      {
        path: "/Distributor/AddDistributor",
        name: "Distributor",
        exact: true,
        element: <AddDistributor />,
      },
      {
        path: "/Distributor/MappingDistributor",
        name: "Distributor",
        exact: true,
        element: <MappingDistributor />,
      },
      {
        path: "/Retailer/AddRetailer",
        name: "Retailer",
        exact: true,
        element: <AddRetailer />,
      },
      {
        path: "/Admin/PendingKycVerification",
        name: "Retailer",
        exact: true,
        element: <PendingKycVerification />,
      },
      {
        path: "/Admin/unblockIPAddressUser",
        name: "Retailer",
        exact: true,
        element: <BlockedIPAddressUsers />,
      },
      {
        path: "/Admin/UserServiceStatus",
        name: "Retailer",
        exact: true,
        element: <UserServiceStatus />,
      },
      {
        path: "/Reports/AdminTopUpReport",
        name: "AccountReport",
        exact: true,
        element: <AdminTopUpReport />,
      },
      {
        path: "/Retailer/Retailer",
        name: "Retailer",
        exact: true,
        element: <Retailer />,
      },
      {
        path: "/Retailer/MappingRetailer",
        name: "Retailer",
        exact: true,
        element: <MappingRetailer />,
      },
      {
        path: "/Admin/AddDocument",
        name: "Retailer",
        exact: true,
        element: <AddDocument />,
      },
      {
        path: "/Admin/UpdateKYC",
        name: "Retailer",
        exact: true,
        element: <UpdateKYC />,
      },
      {
        path: "/Admin/UpdateProfileMenu",
        name: "Retailer",
        exact: true,
        element: <UpdateProfileMenu />,
      },
      {
        path: "/Role/AllRole",
        name: "Role",
        exact: true,
        element: <AllRole />,
      },
      {
        path: "/Role/AddNewRole",
        name: "Role",
        exact: true,
        element: <AddNewRole />,
      },
      {
        path: "/UseManagement/BusinessPartner",
        name: "Business",
        exact: true,
        element: <BusinessPartner />,
      },
      {
        path: "/UseManagement/AddBusinessPartner",
        name: "Business",
        exact: true,
        element: <AddBusiness />,
      },
      {
        path: "/UseManagement/MasterDistributor",
        name: "MasterDistributor",
        exact: true,
        element: <MasterDistributor />,
      },
      {
        path: "/UseManagement/AddMasterDistributor",
        name: "AddMasterDistributor",
        exact: true,
        element: <AddMasterDistributor />,
      },
      {
        path: "/UseManagement/Employee",
        name: "Employee",
        exact: true,
        element: <Employee />,
      },
      {
        path: "/UseManagement/AddEmployee",
        name: "AddEmployee",
        exact: true,
        element: <AddEmployee />,
      },
      {
        path: "/Admin/UserRequest",
        name: "AddEmployee",
        exact: true,
        element: <UserRequest />,
      },
      {
        path: "/Admin/UserRequestDetails",
        name: "AddEmployee",
        exact: true,
        element: <UserRequestDetails />,
      },
      {
        path: "/Admin/SetUserKycAmount",
        name: "AddEmployee",
        exact: true,
        element: <SetUserKycAmount />,
      },

      // Balance Request
      {
        path: "/Admin/ViewBalanceRequestAdmin",
        name: "Admin",
        exact: true,
        element: <ViewBalanceRequestAdmin />,
      },
      {
        path: "/Admin/ViewPendingRequestAdmin",
        name: "Admin",
        exact: true,
        element: <ViewPendingRequestAdmin />,
      },

      // Commission module CreateCommissionPlanMaster
      {
        path: "/Admin/GetCommissionPlanMaster",
        name: "CommissionModule",
        exact: true,
        element: <GetCommissionPlanMaster />,
      },
      {
        path: "/Admin/CreateCommissionPlanMaster",
        name: "CommissionModule",
        exact: true,
        element: <CreateCommissionPlanMaster />,
      },
      {
        path: "/Admin/CreateCommissionMasterTemplateAdmin",
        name: "CommissionModule",
        exact: true,
        element: <CreateCommissionMasterTemplateAdmin />,
      },
      {
        path: "/Admin/CommissionMasterTemplate",
        name: "CommissionModule",
        exact: true,
        element: <GetCommissionMasterTemplate />,
      },

      {
        path: "/Admin/AllPlans",
        name: "PlanMaster",
        exact: true,
        element: <AllPlans />,
      },
      {
        path: "/Admin/AddPlan",
        name: "PlanMaster",
        exact: true,
        element: <AddPlan />,
      },
      {
        path: "/ServiceCategoryMaster/AllServiceCategory",
        name: "ServiceCategoryMaster",
        exact: true,
        element: <AllServiceCategory />,
      },
      {
        path: "/ServiceCategoryMaster/AddServiceCategory",
        name: "ServiceCategoryMaster",
        exact: true,
        element: <AddServiceCategory />,
      },

      // Manage Credit Details
      {
        path: "/ManageCreditDetails/CreditDebitUsers",
        name: "CreditDebit",
        exact: true,
        element: <CreditDebitUsers />,
      },
      {
        path: "/ManageCreditDetails/CreditDebitDetails",
        name: "CreditDebit",
        exact: true,
        element: <CreditDebitDetails />,
      },
      // Manage Bank
      {
        path: "/Admin/AdminSelfBank",
        name: "CreditDebit",
        exact: true,
        element: <AdminSelfBank />,
      },
      {
        path: "/Admin/AdminSelfBankAdd",
        name: "CreditDebit",
        exact: true,
        element: <AdminSelfBankAdd />,
      },
      {
        path: "/SelfBank/AdminSelfbankUpdate",
        name: "CreditDebit",
        exact: true,
        element: <AdminSelfbankUpdate />,
      },
      {
        path: "/Admin/MainBankList",
        name: "CreditDebit",
        exact: true,
        element: <MainBankList />,
      },
      {
        path: "/Admin/BankDataManager",
        name: "BANK",
        exact: true,
        element: <BankDataManager />,
      },
      {
        path: "/Admin/AddMainBank",
        name: "CreditDebit",
        exact: true,
        element: <AddMainBank />,
      },
      {
        path: "/Admin/PaymentOperatorList",
        name: "PaymentOperator",
        exact: true,
        element: <PaymentOperatorList />,
      },
      // Management
      {
        path: "/Admin/ChangeTpin",
        name: "Tpin",
        exact: true,
        element: <ChangeTpinAdmin />,
      },
      {
        path: "/Admin/AppLoginPin",
        name: "AppLoginPin",
        exact: true,
        element: <AppLoginPin />,
      },
      {
        path: "/Admin/ChangeMobileNo",
        name: "ChangeMobileNo",
        exact: true,
        element: <ChangeMobileNo />,
      },
      {
        path: "/Admin/ComplaintManager",
        name: "ComplaintManager",
        exact: true,
        element: <ComplaintManager />,
      },
      {
        path: "/Admin/CustomerLimitInc",
        name: "CustomerLimitInc",
        exact: true,
        element: <CustomerLimitInc />,
      },
      {
        path: "/Admin/CustomerNameUpdate",
        name: "CustomerLimitInc",
        exact: true,
        element: <CustomerNameUpdate />,
      },
      {
        path: "/Admin/EnrollmentList",
        name: "EnrollmentList",
        exact: true,
        element: <EnrollmentList />,
      },
      {
        path: "/Admin/LoginHistory",
        name: "LoginHistory",
        exact: true,
        element: <LoginHistory />,
      },
      {
        path: "/Admin/Notification",
        name: "Notification",
        exact: true,
        element: <Notification />,
      },
      {
        path: "/Admin/NotificationAdd",
        name: "NotificationAdd",
        exact: true,
        element: <NotificationAdd />,
      },
      {
        path: "/Admin/BusinessRights",
        name: "BusinessRights",
        exact: true,
        element: <BusinessRights />,
      },
      {
        path: "/Admin/ServicesControl",
        name: "ServicesControl",
        exact: true,
        element: <ServicesControl />,
      },
      {
        path: "/Admin/UserManagement",
        name: "UserManagement",
        exact: true,
        element: <UserManagement />,
      },
      {
        path: "/Admin/SystemSetting",
        name: "SystemSetting",
        exact: true,
        element: <SystemSetting />,
      },

      //API Cong
      {
        path: "/Admin/appConfig",
        name: "AppConfig",
        exact: true,
        element: <AppConfig />,
      },
      {
        path: '/Admin/APILogs',
        name: 'Reports',
        exact: true,
        element: <APILogs />,
      },
      {
        path: '/Admin/WebHook',
        name: 'Reports',
        exact: true,
        element: <WebHook />,
      },
      {
        path: '/Admin/SMSLogs',
        name: 'Reports',
        exact: true,
        element: <SMSLogs />,
      },
      {
        path: '/Admin/SetCharges',
        name: 'Reports',
        exact: true,
        element: <SetCharges />,
      },
      // Reports
      {
        path: "/Admin/AdminLedgeReports",
        name: "CreditDebit",
        exact: true,
        element: <AdminLedgeReports />,
      },
      {
        path: "/Reports/AdminTransactionReport",
        name: "Reports",
        exact: true,
        element: <AdminTransactionReport />,
      },
      {
        path: "/Reports/AdminBeneficiaryVerifyTransactionReport",
        name: "Reports",
        exact: true,
        element: <AdminBeneficiaryVerifyTransactionReport />,
      },
      {
        path: '/Reports/PendingTransactionReports',
        name: 'Reports',
        exact: true,
        element: <AdminPendingTransectionReport />,
      },
      {
        path: '/Reports/FailedTransactionReports',
        name: 'Reports',
        exact: true,
        element: <AdminFailedTransectionReport />,
      },
      {
        path: "/Reports/AdminWalletToWalletReport",
        name: "Reports",
        exact: true,
        element: <AdminWalletToWalletTransactionReport />,
      },
      {
        path: "/Reports/AdminTransactionByIPAddressReport",
        name: "Reports",
        exact: true,
        element: <AdminTransactionByIPAddressReport />,
      },
      {
        path: "/Admin/AdminChangeStatus",
        name: "Report",
        exact: true,
        element: <AdminChangeStatus />,
      },
      {
        path: "/Reports/AdminBillPaymentReports",
        name: "Reports",
        exact: true,
        element: <AdminBillPaymentReports />,
      },
      {
        path: "/Admin/PayementReciept",
        name: "mobile",
        exact: true,
        element: <PayementReciept />,
      },
      {
        path: "/Reports/KycPaymentsStatus",
        name: "Reports",
        exact: true,
        element: <KycPaymentsStatus />,
      },
      {
        path: "/Reports/AEPSTransactionReportsAdmin",
        name: "Reports",
        exact: true,
        element: <AEPSTransactionReportsAdmin />,
      },
      {
        path: "/Reports/AdminPGReports",
        name: "Reports",
        exact: true,
        element: <AdminPGReports />,
      },
      {
        path: "/Admin/AdminSelfLedger",
        name: "CreditDebit",
        exact: true,
        element: <AdminSelfLedger />,
      },
      {
        path: "/Admin/CommissionReports",
        name: "CreditDebit",
        exact: true,
        element: <CommissionReports />,
      },
      {
        path: "/Admin/CommissionTransectionReports",
        name: "CreditDebit",
        exact: true,
        element: <AdminCommissionTransectionReports />,
      },
      {
        path: "/Admin/PayOutTransactionReports",
        name: "PayOutTransactionReports",
        exact: true,
        element: <PayOutTransactionReports />,
      },
      {
        path: "/Admin/MoneyTransferHoldCaseAdmin",
        name: "MoneyTransferHoldCaseAdmin",
        exact: true,
        element: <MoneyTransferHoldCasesAdmin />,
      },
      {
        path: "/Admin/AdminLedgeReconsileReports",
        name: "Reports",
        exact: true,
        element: <AdminLedgeReconsileReports />,
      },
      {
        path: "/Reports/DaileyTrasactionReports",
        name: "Reports",
        exact: true,
        element: <DaileyTrasactionReports />,
      },

      {
        path: '/Admin/AdminBusinessReport',
        name: 'AccountReport',
        exact: true,
        element: <AdminBusinessReport/>,
      },
      {
        path: '/Admin/AdminBusinessReports',
        name: 'AccountReport',
        exact: true,
        element: <AdminBusinessReports/>,
      },
      {
        path: '/Reports/AdminDailyBusinessReports',
        name: 'AdminDailyBusinessReports',
        exact: true,
        element: <AdminDailyBusinessReports/>,
      },
        {
        path: '/Reports/AccountStatusReports',
        name: 'AdminDailyBusinessReports',
        exact: true,
        element: <AgentAccountStatusReports/>,
      },
      {
        path: "/Admin/APIRequestResponseAdmin",
        name: "Reports",
        exact: true,
        element: <AdminAPIRequestReponseStatus />,
      },
      {
        path: "/Reports/CashoutTransactionReportsAdmin",
        name: "Reports",
        exact: true,
        element: <CashoutTransactionReportsAdmin />,
      },
      {
        path: "/Reports/RefundReportAdmin",
        name: "Reports",
        exact: true,
        element: <RefundReportAdmin />,
      },
        {
        path: "/Reports/RefundReportAdmin",
        name: "Reports",
        exact: true,
        element: <RefundReportAdmin />,
      },
       {
        path: "/Reports/PgTransactionReportsAdmin",
        name: "Reports",
        exact: true,
        element: <PgTransactionReportsAdmin />,
      },
    ],
  },
  // SUPER DISTRIBUTOR SCREEN
  {
    path: "/",
    element: <ProtectRouteSuper Component={SuperLayout} />,
    children: [
      {
        path: "/dashboards/superdistributordashboard",
        name: "superDistributor",
        exact: true,
        element: <SuperDistributorDashboard />,
      },
      {
        path: "/SuperDistributor/AddDocumentKyc",
        name: "superDistributor",
        exact: true,
        element: <SuperDocumentKyc />,
      },
      {
        path: "/SuperDistributor/UpdateProfileMenu",
        name: "superDistributor",
        exact: true,
        element: <UpdateProfileMenuSD />,
      },

      {
        path: "/SuperDistributor/AllPlans",
        name: "superDistributor",
        exact: true,
        element: <AllPlansSD />,
      },
      {
        path: "/SuperDistributor/AddPlan",
        name: "superDistributor",
        exact: true,
        element: <AddPlanSD />,
      },

      {
        path: "/dashboards/SuperViewRetailerDistributor",
        name: "superDistributor",
        exact: true,
        element: <SuperViewRetailerDistributor />,
      },
      {
        path: "/dashboards/SuperCreateRetailerDistributor",
        name: "superDistributor",
        exact: true,
        element: <SuperCreateRetailerDistributor />,
      },
      {
        path: "/superDistributor/DistributorDocs",
        name: "superDistributor",
        exact: true,
        element: <DistributorDocs />,
      },
      {
        path: "/dashboards/SuperManageCreditDebitDistributor",
        name: "superDistributor",
        exact: true,
        element: <SuperManageCreditDebitDistributor />,
      },
      {
        path: "/dashboards/SuperCreditAmountToRetailer",
        name: "superDistributor",
        exact: true,
        element: <SuperCreditAmountToRetailer />,
      },
      {
        path: "/dashboards/SuperCreditDetailsDistributor",
        name: "superDistributor",
        exact: true,
        element: <SuperCreditDetailsDistributor />,
      },
      // Profile
      {
        path: "/Profile/UpdateProfileSD",
        name: "UpdateProfileSD",
        exact: true,
        element: <UpdateProfileSD />,
      },
      {
        path: "/SuperDistributor/ChangePasswordSP",
        name: "ChangePasswordSP",
        exact: true,
        element: <ChangePasswordSP />,
      },

      // SELF BANK
      {
        path: "/SuperDistributor/AddNewBankSuperDistributor",
        name: "AddNewBank",
        exact: true,
        element: <AddNewBankSuperDistributor />,
      },
      {
        path: "/SuperDistributor/SPDistributorBankList",
        name: "SPDistributorBankList",
        exact: true,
        element: <SPDistributorBankList />,
      },
      {
        path: "/SuperDistributor/UpdateSPDistributorBank",
        name: "UpdateSPDistributorBank",
        exact: true,
        element: <UpdateSPDistributorBank />,
      },
      {
        path: "/SuperDistributor/BalanceRequestHistorySuper",
        name: "BalanceRequestHistorySuper",
        exact: true,
        element: <BalanceRequestHistorySuper />,
      },
      {
        path: "/SuperDistributor/NewBalanceRequestSuper",
        name: "NewBalanceRequestSuper",
        exact: true,
        element: <NewBalanceRequestSuper />,
      },
      {
        path: "/SuperDistributor/PendingBalanceRequestSuperDistributor",
        name: "PendingBalanceRequestSuperDistributor",
        exact: true,
        element: <PendingBalanceRequestSuperDistributor />,
      },
      {
        path: "/dashboards/LedgerSuperReportDistributor",
        name: "superDistributor",
        exact: true,
        element: <LedgerSuperReportDistributor />,
      },
      {
        path: "/SuperDistributor/AllReports",
        name: "AllReports",
        exact: true,
        element: <AllSuperDistributorReports />,
      },
      {
        path: '/SuperDistributor/CommisionSuperReportDistributor',
        name: 'CommisionReportDistributor',
        exact: true,
        element: <CommisionSuperReportDistributor/>,
      },
      {
        path: "/DMT/TransactionRecieptSDistributor",
        name: "TransactionReciept",
        exact: true,
        element: <TransactionRecieptDistributor />,
      },
      {
        path: '/SuperDistributor/AEPSTransactionReciept',
        name: 'AEPS',
        exact: true,
        element: <AEPSTransactionReciept />,
      },
      {
        path: '/SuperDistributor/BillPaymentReciept',
        name: 'AEPS',
        exact: true,
        element: <BillPaymentReciept />,
      },
    ],
  },

  // DISTRIBUTOR SCREEN

  {
    path: "/",
    element: <ProtectRouteDistributor Component={DistributorLayout} />,
    children: [
      {
        path: "/dashboards/distributordashboard",
        name: "Distributor",
        exact: true,
        element: <DistributorDashboard />,
      },
      {
        path: "/Distributor/AddDocumentKyc",
        name: "Distributor",
        exact: true,
        element: <DistributorDocsKyc />,
      },
      {
        path: "/Distributor/CreateRetailer",
        name: "Distributor",
        exact: true,
        element: <CreateRetailerDistributor />,
      },
      {
        path: "/Distributor/ViewRetailerDistributor",
        name: "Distributor",
        exact: true,
        element: <ViewRetailerDistributor />,
      },
      {
        path: "/Distributor/RetailerDocs",
        name: "Distributor",
        exact: true,
        element: <RetailerDocs />,
      },
      {
        path: "/Distributor/ManageCreditDebitDistributor",
        name: "Distributor",
        exact: true,
        element: <ManageCreditDebitDistributor />,
      },
      {
        path: "/Distributor/CreditAmountToRetailer",
        name: "Distributor",
        exact: true,
        element: <CreditAmountToRetailer />,
      },
      {
        path: "/Distributor/CreditDetailsDistributor",
        name: "Distributor",
        exact: true,
        element: <CreditDetailsDistributor />,
      },
      {
        path: "/Profile/UpdateProfileDistributor",
        name: "UpdateProfileDistributor",
        exact: true,
        element: <UpdateProfileDistributor />,
      },
      {
        path: "/DMT/TransactionRecieptDistributor",
        name: "TransactionReciept",
        exact: true,
        element: <TransactionRecieptDistributor />,
      },
      {
        path: "/dashboards/LedgerReportDistributor",
        name: "Distributor",
        exact: true,
        element: <LedgerReportDistributor />,
      },

      {
        path: "/Distributor/UpdateProfileMenu",
        name: "Distributor",
        exact: true,
        element: <UpdateProfileMenuD />,
      },

      {
        path: "/Distributor/AllPlans",
        name: "Distributor",
        exact: true,
        element: <AllPlansD />,
      },
      {
        path: "/Distributor/AddPlan",
        name: "Distributor",
        exact: true,
        element: <AddPlanD />,
      },

      {
        path: "/Distributor/ChangePasswordDistributer",
        name: "Distributor",
        exact: true,
        element: <ChangePasswordDistributer />,
      },
      // BALANCE REQUEST
      {
        path: "/Distributor/BalanceRequestHistoryDistributor",
        name: "Distributor",
        exact: true,
        element: <BalanceRequestHistoryDistributor />,
      },
      {
        path: "/Distributor/PendingBalanceRequestDistributor",
        name: "Distributor",
        exact: true,
        element: <PendingBalanceRequestDistributor />,
      },
      {
        path: "/Distributor/NewBalanceRequestDistributor",
        name: "Distributor",
        exact: true,
        element: <NewBalanceRequestDistributor />,
      },
      // SELF BANK
      {
        path: "/Distributor/AddNewBankDistributor",
        name: "Distributor",
        exact: true,
        element: <AddNewBankDistributor />,
      },
      {
        path: "/Distributor/DistributorBankList",
        name: "Distributor",
        exact: true,
        element: <DistributorBankList />,
      },
      {
        path: "/Distributor/UpdateDistributorBank",
        name: "Distributor",
        exact: true,
        element: <UpdateDistributorBank />,
      },
      {
        path: "/Reports/AllReports",
        name: "AllReports",
        exact: true,
        element: <AllRetailorReportsDistributor />,
      },
      {
        path: '/dashboards/CommisionReportDistributor',
        name: 'CommisionReportDistributor',
        exact: true,
        element: <CommisionReportDistributor/>,
      },
      {
        path: '/Distributor/AEPSTransactionReciept',
        name: 'AEPS',
        exact: true,
        element: <AEPSTransactionReciept />,
      },
      {
        path: '/Distributor/BillPaymentReciept',
        name: 'AEPS',
        exact: true,
        element: <BillPaymentReciept />,
      },
    ],
  },

  // RETAILER SCREEN
  {
    path: "/",
    element: <ProtectRouteAgent Component={FullLayout} />,
    children: [
      {
        path: "/dashboards/retailerdashboard",
        name: "Retailer",
        exact: true,
        element: <RetailerDashboard />,
      },
      {
        path: "/dashboards/TermsAndCondition",
        name: "Retailer",
        exact: true,
        element: <RetailerTermsAndCondition />,
      },
      {
        path: "/dashboards/PrivacyPolicy",
        name: "Retailer",
        exact: true,
        element: <RetailerPrivacyPolicy />,
      },
      // Banking Services
      {
        path: "/DMT/DMTDashboard",
        name: "DMTDashboard",
        exact: true,
        element: <DMTDashboard />,
      },
      {
        path: "/DMT/SearchCustomer",
        name: "DMTDashboard",
        exact: true,
        element: <SearchCustomer />,
      },
      {
        path: "/DMT/AddCustomer",
        name: "DMTDashboard",
        exact: true,
        element: <AddCustomer />,
      },
      {
        path: "/Benificiary/BenificiaryList",
        name: "BenificiaryList",
        exact: true,
        element: <BenificiaryList />,
      },
      {
        path: "/Benificiary/AddBenificiary",
        name: "AddBenificiary",
        exact: true,
        element: <AddBenificiary />,
      },
      {
        path: "/Benificiary/BenificiaryDetails",
        name: "BenificiaryDetails",
        exact: true,
        element: <BenificiaryDetails />,
      },
      {
        path: "/DMT/TransactionReciept",
        name: "TransactionReciept",
        exact: true,
        element: <TransactionReciept />,
      },
      // Payment Collection
      {
        path: "/Agent/paymentCollectionRetailer",
        name: "PaymentCollection",
        exact: true,
        element: <PCSearchCustomer />,
      },
      // Payout-4 (DIGIKHATA)
      {
        path: "/Agent/SearchDigiCustomer",
        name: "SearchDigiCustomer",
        exact: true,
        element: <SearchDIGICustomer />,
      },
      {
        path: "/Agent/DigiKhataBenificiary",
        name: "SearchDigiCustomer",
        exact: true,
        element: <DGKBenificiaryDetails />,
      },
      // PAYOUT-1
      {
        path: "/RentPayoutDashboard",
        name: "PAYOUT",
        exact: true,
        element: <RentPayoutDashboard />,
      },
      {
        path: "/Agent/SearchPayoutCustomer",
        name: "PAYOUT",
        exact: true,
        element: <SearchPayoutCustomer />,
      },
      {
        path: "/Agent/SearchCustomer",
        name: "PAYOUT",
        exact: true,
        element: <SearchCustomerList />,
      },
      {
        path: "/Agent/SearchCustomers",
        name: "PAYOUT",
        exact: true,
        element: <SearchCustomerListSOLICITEK />,
      },
      {
        path: "/Agent/AddCustomerPayout",
        name: "PAYOUT",
        exact: true,
        element: <AddCustomerPayout />,
      },
      {
        path: "/Agent/PayAddBeneficiary",
        name: "PAYOUT",
        exact: true,
        element: <PayAddBeneficiary />,
      },
      {
        path: "/Agent/PayoutBeneficiaryList",
        name: "PAYOUT",
        exact: true,
        element: <PayoutBeneficiaryList />,
      },
      {
        path: "/Agent/PayOutBeniDetails",
        name: "PAYOUT",
        exact: true,
        element: <PayOutBeniDetails />,
      },
      {
        path: "/SelfBank/RetailorBankList",
        name: "RetailorBankList",
        exact: true,
        element: <RetailorBankList />,
      },
      {
        path: "/SelfBank/AddNewBank",
        name: "AddNewBank",
        exact: true,
        element: <AddNewBank />,
      },
      {
        path: "/SelfBank/UpdateRetailorBank",
        name: "UpdateRetailorBank",
        exact: true,
        element: <UpdateRetailorBank />,
      },
      {
        path: "/Reports/AllRetailorReports",
        name: "AllRetailorReports",
        exact: true,
        element: <AllRetailorReports />,
      },
      {
        path: "/Reports/CashoutReport",
        name: "CashoutReport",
        exact: true,
        element: <CashoutReport />,
      },
      
      // profile
      {
        path: "/Profile/UpdateProfileAgent",
        name: "UpdateProfileAgent",
        exact: true,
        element: <UpdateProfileAgent />,
      },
      {
        path: "/Profile/Certificate",
        name: "Certificate",
        exact: true,
        element: <Certificate />,
      },
      {
        path: "/Agent/SetTPIN",
        name: "SetTPIN",
        exact: true,
        element: <SetTPIN />,
      },
      {
        path: "/Agent/ResetTPIN",
        name: "ResetTPIN",
        exact: true,
        element: <ResetTPIN />,
      },

      {
        path: "/Agent/ChangePassword",
        name: "ChangePassword",
        exact: true,
        element: <ChangePassword />,
      },

      // Balance Request
      {
        path: "/Agent/BalanceRequestHistory",
        name: "BalanceRequestHistory",
        exact: true,
        element: <BalanceRequestHistory />,
      },
      {
        path: "/Agent/NewBalanceRequest",
        name: "NewBalanceRequest",
        exact: true,
        element: <NewBalanceRequest />,
      },
      // Comlaint
      {
        path: "/Agent/ComplaintListAgent",
        name: "ComplaintListAgent",
        exact: true,
        element: <ComplaintListAgent />,
      },
      {
        path: "/Agent/ComplaintAddAgent",
        name: "ComplaintAddAgent",
        exact: true,
        element: <ComplaintAddAgent />,
      },
      // Bill Paymnet

      {
        path: "/Agent/BillPaymentsBa",
        name: "BillPayments",
        exact: true,
        element: <BillPaymentsBa />,
      },
      {
        path: "/Agent/BillPaymentsDash",
        name: "BillPayments",
        exact: true,
        element: <BillPaymentsDash />,
      },
      
      {
        path: "/Agent/BillPaymentsInd",
        name: "BillPayments",
        exact: true,
        element: <BillPaymentsInd />,
      },
      {
        path: "/Agent/DTH",
        name: "DTH",
        exact: true,
        element: <DTHRecharge />,
      },
      {
        path: "/Agent/MobileRecharge",
        name: "mobile",
        exact: true,
        element: <MobileRecharge />,
      },
      {
        path: "/Agent/PayementReciept",
        name: "mobile",
        exact: true,
        element: <PayementReciept />,
      },
      {
        path: "/Agent/LICPayments",
        name: "LIC",
        exact: true,
        element: <LICPayments />,
      },
      {
        path: "/Agent/LPGGasPayment",
        name: "LIC",
        exact: true,
        element: <LPGGasPayment />,
      },
      {
        path: "/Agent/ElectricityBill",
        name: "electricityBill",
        exact: true,
        element: <ElectricityBill />,
      },
      {
        path: "/Agent/FastTag",
        name: "FastTagPayment",
        exact: true,
        element: <FastTagPayment />,
      },
      // WALLET PAY
      {
        path: "/Agent/WalletPay",
        name: "WalletPay",
        exact: true,
        element: <WalletPay />,
      },
      // WALLET To WALLET
      {
        path: "/Agent/WalletToWallet",
        name: "WalletToWallet",
        exact: true,
        element: <WalletToWallet />,
      },
      // REMITTER
      {
        path: "/Agent/REMITTER",
        name: "REMITTER",
        exact: true,
        element: <REMITTER />,
      },
      {
        path: "/Agent/PipDMTSearchCustomer",
        name: "DMTDashboard",
        exact: true,
        element: <PipDMTSearchCustomer />,
      },
      {
        path: "/Retailer/AddDocumentKyc",
        name: "AddDocumentKyc",
        exact: true,
        element: <AddDocumentKyc />,
      },
      // AEPS SCREEN
      {
        path: "/Agent/AEPSOnboarding",
        name: "AEPS",
        exact: true,
        element: <AEPSOnboarding />,
      },
      {
        path: "/Agent/AepsSearch",
        name: "AEPS",
        exact: true,
        element: <AepsSearch />,
      },
      {
        path: "/Agent/AEPSCaptureIs",
        name: "AEPS",
        exact: true,
        element: <AEPSCaptureIs />,
      },
      {
        path: "/Agent/OnboardingUser",
        name: "AEPS",
        exact: true,
        element: <OnboardingUser />,
      },
      {
        path: "/Agent/AEPSSearchPs",
        name: "AEPS",
        exact: true,
        element: <AEPSSearchPs />,
      },
      {
        path: "/Agent/AEPSDailyAuthantication",
        name: "AEPS",
        exact: true,
        element: <AEPSDailyAuthantication />,
      },
      {
        path: "/Agent/AEPSRegistrationUser",
        name: "AEPS",
        exact: true,
        element: <AEPSRegistrationUser />,
      },
      {
        path: "/Agent/AEPSWithdralCapture",
        name: "AEPS",
        exact: true,
        element: <AEPSWithdralCapture />,
      },
      {
        path: "/Agent/AEPSBalAndMinistatment",
        name: "AEPS",
        exact: true,
        element: <AEPSBalAndMinistatment />,
      },
      {
        path: "/Agent/AEPSTransactionSelect",
        name: "AEPS",
        exact: true,
        element: <AEPSTransactionSelect />,
      },
      {
        path: "/Agent/AEPSTransactionReciept",
        name: "AEPS",
        exact: true,
        element: <AEPSTransactionReciept />,
      },
      {
        path: "/Agent/AEPSToDMTTransfer",
        name: "AEPS",
        exact: true,
        element: <AEPSToDMTTransfer />,
      },
      {
        path: "/Agent/AEPSPayoutBeneficiaryDetails",
        name: "AEPS",
        exact: true,
        element: <AEPSPayoutBeneficiaryDetails />,
      },
      {
        path: "/Agent/AEPSPayout",
        name: "AEPS",
        exact: true,
        element: <AEPSPayout />,
      },
      // {
      //   path: '/Agent/AEPSTransactionReports',
      //   name: 'AEPS',
      //   exact: true,
      //   element: <AEPSTransactionReports />,
      // },
      // QRSERVICES
      {
        path: "/Agent/QRServices",
        name: "AEPS",
        exact: true,
        element: <QRServices />,
      },

      // PG
      {
        path: "/Agent/PaymentGetway",
        name: "PG",
        exact: true,
        element: <PaymentGetway />,
      },
      {
        path: "/Agent/PaymentGetway1",
        name: "PG",
        exact: true,
        element: <PaymentGetway1 />,
      },
      {
        path: "/Agent/PaymentGetway2",
        name: "PG",
        exact: true,
        element: <PaymentGetway2 />,
      },
       {
        path: "/Agent/PaymentGetway4",
        name: "PG",
        exact: true,
        element: <PaymentGetwayVegaah />,
      },
        {
        path: "/Agent/UpiEcollection",
        name: "PG",
        exact: true,
        element: <UpiEcollection />,
      },
        {
        path: "/Agent/PGToMainWalletTransfer",
        name: "PGToMainWalletTransfer",
        exact: true,
        element: <PGToMainWalletTransfer />,
      },
      // PG Dashboard
      {
        path: "/Agent/PaymentGetwayDashboard",
        name: "PGDashboard",
        exact: true,
        element: <PaymentGetwayDashboard />,
      },
      // CMS
      {
        path: "/Agent/GetCMSLink",
        name: "CMS",
        exact: true,
        element: <GetCMSLink />,
      },
      {
        path: "/Agent/QuickDhanPay",
        name: "CMS",
        exact: true,
        element: <QuickDhanPay />,
      },
      {
        path: "/Agent/BusBooking",
        name: "CMS",
        exact: true,
        element: <BusBooking />,
      },

      // Reports
      {
        path: "/Reports/LedgerReport",
        name: "LedgerReport",
        exact: true,
        element: <AgentLedgerReport />,
      },
      {
        path: "/Reports/TransactionReport",
        name: "TransactionReport",
        exact: true,
        element: <AgentTransactionReport/>,
      },
      {
        path: "/Reports/BeneVerifyReport",
        name: "BeneVerifyReport",
        exact: true,
        element: <AgentBeneVerifyReport />,
      },
      {
        path: "/Reports/AEPSTransactionReport",
        name: "AEPSTransactionReport",
        exact: true,
        element: <AgentAEPSTransactionReport/>,
      },
      {
        path: "/Reports/PGTransactionReport",
        name: "PGTransactiontReport",
        exact: true,
        element: <AgentPGTransactionReport />,
      },
      {
        path: "/Reports/TDSTransactionReport",
        name: "TDSTransactiontReport",
        exact: true,
        element: <AgentTDSTransactionReport/>,
      },
      {
        path: "/Reports/GSTTransactionReport",
        name: "GSTTransactionReport",
        exact: true,
        element: <AgentGSTTransactionReport />,
      },
      {
        path: "/Reports/AgentBillPayementReport",
        name: "AgentBillPayementReport",
        exact: true,
        element: <AgentBillPayementReport/>,
      },
      {
        path: "/Agent/developerDocuments", 
        name: "developerDocuments",
        exact: true,
        element: <DevelopersDocument />,
      },
    ],
  },
  // BUSINESS SCREEN
  {
    path: "/",
    element: <ProtectRouteBusiness Component={BusinessLayout} />,
    children: [
      {
        path: "/Dashboards/BusinessPartnerDashboard",
        name: "Business",
        exact: true,
        element: <BusinessPartnerDashboard />,
      },
      // Balance Request CreateBalanceRequest
      {
        path: "/Business/BalanceRequestHistoryBusiness",
        name: "Business",
        exact: true,
        element: <BalanceRequestHistoryBusiness />,
      },
      {
        path: "/Business/CreateBalanceRequest",
        name: "Business",
        exact: true,
        element: <CreateBalanceRequest />,
      },
      // self Bank
      {
        path: "/Business/BusinessBankList",
        name: "Business",
        exact: true,
        element: <BusinessBankList />,
      },
      {
        path: "/Business/AddBusinessBank",
        name: "Business",
        exact: true,
        element: <AddBusinessBank />,
      },
      {
        path: "/Business/UpdateBusinessBank",
        name: "Business",
        exact: true,
        element: <UpdateBusinessBank />,
      },
      {
        path: "/Profile/UpdateProfileBusiness",
        name: "Business",
        exact: true,
        element: <UpdateProfileBusiness />,
      },
      {
        path: "/Business/ChangePasswordBD",
        name: "Business",
        exact: true,
        element: <ChangePasswordBD />,
      },
    ],
  },
  // MASTER SCREEN
  {
    path: "/",
    element: <ProtectRouteMaster Component={MasterLayout} />,
    children: [
      {
        path: "/Dashboards/MasterDistributorDashboard",
        name: "MasterDistributor",
        exact: true,
        element: <MasterDistributorDashboard />,
      },
      {
        path: "/MasterDistributor/AddDocumentKyc",
        name: "MasterDocumentKyc",
        exact: true,
        element: <MasterDocumentKyc />,
      },
      //Balance Request
      {
        path: "/MasterDistributor/NewBalanceRequestMaster",
        name: "MasterDistributor",
        exact: true,
        element: <NewBalanceRequestMaster />,
      },
      {
        path: "/dashboards/MasterViewSuperDistributor",
        name: "MasterDistributor",
        exact: true,
        element: <MasterViewSuperDistributor />,
      },
      {
        path: "/dashboards/MasterCreateSuperDistributor",
        name: "MasterDistributor",
        exact: true,
        element: <MasterCreateSuperDistributor />,
      },
      {
        path: "/MasterDistributor/SuperDistributorDocs",
        name: "MasterDistributor",
        exact: true,
        element: <SuperDistributorDocs />,
      },
      {
        path: "/MasterDistributor/BalanceRequestHistoryMaster",
        name: "MasterDistributor",
        exact: true,
        element: <BalanceRequestHistoryMaster />,
      },
      {
        path: "/dashboards/MasterManageCreditDebitDistributor",
        name: "superDistributor",
        exact: true,
        element: <MasterManageCreditDebitDistributor />,
      },
      {
        path: "/dashboards/MasterCreditAmountToRetailer",
        name: "superDistributor",
        exact: true,
        element: <MasterCreditAmountToRetailer />,
      },
      //credit details
      {
        path: "/MasterDistributor/MasterCreditDetails",
        name: "MasterDistributor",
        exact: true,
        element: <MasterCreditDetails />,
      },
      // reports
      {
        path: "/dashboards/LedgerMasterReportDistributor",
        name: "MasterDistributor",
        exact: true,
        element: <LedgerMasterReportDistributor />,
      },
      // self bank
      {
        path: "/MasterDistributor/MasterBankList",
        name: "MasterDistributor",
        exact: true,
        element: <MasterBankList />,
      },
      {
        path: "/MasterDistributor/AddMasterBank",
        name: "MasterDistributor",
        exact: true,
        element: <AddMasterBank />,
      },
      {
        path: "/MasterDistributor/UpdateMasterBank",
        name: "MasterDistributor",
        exact: true,
        element: <UpdateMasterBank />,
      },
      {
        path: "/MasterDistributor/ChangePasswordMd",
        name: "MasterDistributor",
        exact: true,
        element: <ChangePasswordMd />,
      },
      {
        path: "/Profile/ProfileUpdateMD",
        name: "MasterDistributor",
        exact: true,
        element: <UpdateProfileMD />,
      },
    ],
  },
  //EMPLOYE SCREEN
  {
    path: "/",
    element: <ProtectRouteEmploye Component={EmployeLayout} />,
    children: [
      {
        path: "/Dashboards/EmployeeDashboard",
        name: "Employee",
        exact: true,
        element: <EmployeeDashboard />,
      },
      // Balance Request NewBalanceRequestEmployee BalanceRequestHistoryEmployee
      {
        path: "/Employee/NewBalanceRequestEmployee",
        name: "Employee",
        exact: true,
        element: <NewBalanceRequestEmployee />,
      },
      {
        path: "/Employee/BalanceRequestHistoryEmployee",
        name: "Employee",
        exact: true,
        element: <BalanceRequestHistoryEmployee />,
      },
      // Self Bank EmployeeBankList AddEmployeeBank UpdateEmployeeBank
      {
        path: "/Employee/EmployeeBankList",
        name: "Employee",
        exact: true,
        element: <EmployeeBankList />,
      },
      {
        path: "/Employee/AddEmployeeBank",
        name: "Employee",
        exact: true,
        element: <AddEmployeeBank />,
      },
      {
        path: "/Employee/UpdateEmployeeBank",
        name: "Employee",
        exact: true,
        element: <UpdateEmployeeBank />,
      },
      {
        path: "/Employee/ChangePasswordEMP",
        name: "Employee",
        exact: true,
        element: <ChangePasswordEMP />,
      },
    ],
  },
  // SUPER ADMIN SCREEN
  {
    path: "/",
    element: <ProtectRouteSuperAdmin Component={SuperAdminLayout} />,
    children: [
      {
        path: "/Dashboards/SuperAdminDashboard",
        name: "SuperAdmin",
        exact: true,
        element: <SuperAdminDashboard />,
      },
      {
        path: "/SuperAdmin/AddApi",
        name: "ApiMaster",
        exact: true,
        element: <AddApi />,
      },
      {
        path: "/SuperAdmin/AllApi",
        name: "ApiMaster",
        exact: true,
        element: <AllApi />,
      },
      {
        path: "/SuperAdmin/UpdateApi",
        name: "ApiMaster",
        exact: true,
        element: <UpdateApi />,
      },
      {
        path: "/SuperAdmin/CreateCommissionMasterTemplate",
        name: "CommissionMaster",
        exact: true,
        element: <CreateCommissionMasterTemplate />,
      },
      {
        path: "/SuperAdmin/GetCommissionMasterTemplate",
        name: "CommissionMaster",
        exact: true,
        element: <AdminGetCommissionMasterTemplate />,
      },

      {
        path: "/SuperAdmin/AllServices",
        name: "ServiceMaster",
        exact: true,
        element: <AllServices />,
      },
      {
        path: "/SuperAdmin/AddServices",
        name: "ServiceMaster",
        exact: true,
        element: <AddServices />,
      },
    ],
  },
];

export default ThemeRoutes;
